import { RouteObject } from 'react-router-dom';
import { Inventory } from '../Inventory';
import { GeographyRoutes } from '../pages/Geography/routes/GeographyRoutes';
import { UsersRoutes } from '../pages/Users/routes';
import { AssetsRoutes } from '../pages/Assets/routes';
import { AssignmentsRoutes } from '../pages/Assignments/routes';
import { RequestsRoute } from '../pages/Requests/routes/RequestRoute';
import ServiceHistoryRoutes from '../pages/ServiceHistory/routes/ServiceHistoryRoutes';

export const InventoryRoutes: RouteObject[] = [
  {
    path: '',
    element: <Inventory />,
  },
  ...GeographyRoutes,
  ...UsersRoutes,
  ...AssetsRoutes,
  ...AssignmentsRoutes,
  ...RequestsRoute,
  ...ServiceHistoryRoutes,
];
